import React, { useState, useEffect } from 'react';

export default function Donaciones() {
    return (
        <div></div>
    )
}